module.exports = __webpack_public_path__ + "roboto-regular-webfont.c580689ec4ba327cccfe.woff2";


//////////////////
// WEBPACK FOOTER
// /home/vatzcar/public_html/BEX-KYC-Admin/src/assets/fonts/roboto-regular-webfont.woff2
// module id = ../../../../../src/assets/fonts/roboto-regular-webfont.woff2
// module chunks = styles